// Module
var code = "<div class=\"universal-image-actions-one-page-buttons\"> <button class=\"btn btn-default pull-right\" ng-click=\"model.close()\" ng-disabled=\"model.disableDoneButton()\"> Done </button> </div> ";
// Exports
module.exports = code;